import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import ExpertSignup from "@/pages/ExpertSignup";
import ExpertCompleteProfile from "@/pages/ExpertCompleteProfile";
import ExpertDashboard from "@/pages/ExpertDashboard";
import IndustryAuth from "@/pages/IndustryAuth";
import IndustryPrompt from "@/pages/IndustryPrompt";
import IndustryProjects from "@/pages/IndustryProjects";
import ProjectDetail from "@/pages/ProjectDetail";
import AdminPanel from "@/pages/AdminPanel";
import OpportunityPage from "@/pages/OpportunityPage";
import UniversityRegister from "@/pages/UniversityRegister";
import UniversityLogin from "@/pages/UniversityLogin";
import UniversityDashboard from "@/pages/UniversityDashboard";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/expert/signup" element={<ExpertSignup />} />
            <Route path="/expert/complete-profile" element={<ExpertCompleteProfile />} />
            <Route path="/expert/dashboard" element={<ExpertDashboard />} />
            <Route path="/industry/auth" element={<IndustryAuth />} />
            <Route path="/industry/prompt" element={<IndustryPrompt />} />
            <Route path="/industry/projects" element={<IndustryProjects />} />
            <Route path="/industry/projects/:id" element={<ProjectDetail />} />
            {/* Legacy search flow removed — redirect to project creation */}
            <Route path="/search" element={<Navigate to="/industry/projects" replace />} />
            <Route path="/expert/:id" element={<Navigate to="/" replace />} />
            <Route path="/opportunities/:id" element={<OpportunityPage />} />
            <Route path="/ch-admin" element={<AdminPanel />} />
            <Route path="/ch-admin-panel" element={<AdminPanel />} />
            <Route path="/university-register" element={<UniversityRegister />} />
            <Route path="/university/login" element={<UniversityLogin />} />
            <Route path="/university/dashboard" element={<UniversityDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
